import { useCallback } from 'react';

import * as events from 'utils/events';

/**
 * custom hook handler to call method parameter event when the user pressed the keyboard "Enter" key
 * @param onEnter event to trigger upon successful left click
 */
export default function useKeyboardEnter(onEnter: (e: React.KeyboardEvent) => void) {
  return useCallback((e: React.KeyboardEvent) => events.onKeyboardEnter(onEnter)(e), [onEnter]);
}
